import { Switch } from 'react-router-dom'
import { CIMSPage, Permission } from 'shared'
import { ProtectedRoute } from 'components/ProtectedRoute'
import BatchReports from './components/BatchReports'
import DesignLayers from './components/PDFDesignLayers'
import SingleReports from './components/SingleReports'
import PhotoExports from './components/PhotoExports'
import SingleReportsProvider from './components/SingleReports/SingleReportsContext'
import Filenames from './components/Filenames'
import ReportRecordSelectProvider from 'components/CIMSSelect/common/ReportRecordSelect/ReportRecordSelectContext'
import CSV from './components/CSV'

const ImportsExports: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={CIMSPage.CSV.projectPath}
        permissions={[Permission.ImportCSV, Permission.ExportCSV]}
      >
        <CSV />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.PDFReports.projectPath}
        permissions={Permission.CreateReport}
      >
        <ReportRecordSelectProvider>
          <SingleReportsProvider>
            <SingleReports />
          </SingleReportsProvider>
        </ReportRecordSelectProvider>
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.BatchReports.projectPath}
        permissions={Permission.CreateBatchReportRequest}
      >
        <BatchReports />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.PDFDesignLayers.projectPath}
        permissions={Permission.ViewPDFDesignLayer}
      >
        <DesignLayers />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.PhotoExports.projectPath}
        permissions={Permission.CreatePhotoExportRequest}
      >
        <PhotoExports />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.Filenames.projectPath}
        permissions={Permission.ViewFilename}
      >
        <Filenames />
      </ProtectedRoute>
    </Switch>
  )
}

export default ImportsExports
